import { Label, Text } from '@fluentui/react';
import { textProp } from 'global/Application';
import { IBooleanValue } from 'model/FlexibleAttributeModel';
import React from 'react';
import ToggleOptions, { IToggleOptionsProps } from './ToggleOptions';
import { IToggleOption } from './ToggleOptions/IToggleOption.type';

export type IBooleanToggleOption = IToggleOption<IBooleanValue>;

interface IProps extends Partial<IToggleOptionsProps> {
    label?: string;
    fieldValueOnChange?: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: IBooleanValue) => void;
    defaultFieldValue?: IBooleanValue;
    disabled?: boolean;
    options?: IBooleanToggleOption[];
    styles?: any;
    unclick?: boolean;
}

const OptionControl: React.FunctionComponent<IProps> = (props) => {

    const fieldValueOnChange = (event: React.MouseEvent<HTMLElement, MouseEvent>, option?: IBooleanToggleOption) => {
        props.fieldValueOnChange?.(event, option?.data!);
    }

    const options: IBooleanToggleOption[] = props.options ?? [
        // { key: '<unset>', text: '<Empty>' },
        { key: 'Yes', text: 'Yes', data: { type: 'bool', value: true } },
        { key: 'No', text: 'No', data: { type: 'bool', value: false } },
    ]

    let selectedKey: string | null = null;

    if (props.defaultFieldValue?.value === true)
        selectedKey = "Yes";
    else if (props.defaultFieldValue?.value === false)
        selectedKey = "No"

    if (props.disabled)
        return <div style={textProp.root.style}>
            <Label styles={textProp.label}>{props.label}</Label>
            <Text styles={textProp.textStyles}>{selectedKey ?? '---'}</Text>
        </div>;


    return (
        <ToggleOptions
            label={props.label}
            options={options}
            onChange={fieldValueOnChange}
            defaultSelectedKey={selectedKey}
            disableClear={props.disableClear}
            disabled={props.disabled}
            styles={props.styles}
            unclick={props.unclick}
        />
    )
}


export default OptionControl